
import AlertDialogOnClose from "../../../../components/admin/AlertDiologOnClose";
import ListaArComprimido from "./ListaArComprimido";
export default function ArComprimidoForm() {
    return(
        <AlertDialogOnClose nome={"Ar Comprimido"} placeholder={"Insira o nome do equipamento"}>
        	<ListaArComprimido />
        </AlertDialogOnClose>
    )
} 